import { Component, OnInit } from '@angular/core';

import { GlobalService } from '../../../services/global.service';
import { SnackBarService } from '../../../shared/snackbar/snackbar.service';
import { LoadingService } from '../../../shared/loading/loading.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../auth/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from '../../../services/user.service';

import Utils from '../../../shared/utility';

@Component({
  selector: 'app-nw-external-users',
  templateUrl: './external-users.component.html',
  styleUrls: ['./external-users.component.css']
})
export class ExternalUserNWComponent implements OnInit {

  private error:string;
  message: string = 'You should be redirected in just a moment...';


  constructor(public dialog: MatDialog, private globalService: GlobalService, 
    private snackBarService: SnackBarService, private loadingService: LoadingService, public router: Router,
    public route: ActivatedRoute, public authService: AuthService, private userService: UserService) { 
      //find variabled being passed to the UI

  }

  ngOnInit() {
    this.loadingService.isLoading(true);
    //make call to the API
    var query = this.router.url.split('/login-sso/');
    console.log('query from SSO EX', query);

    //if returned true, display reports for the client selected
    if(query[1] != "false"){
      this.message = 'Successfully connected to your account. Just a few more moments while we set things up.';
      this.validateUser(query[1]);
    } else {
      this.message = "There might have been a timeout connecting to your account. Single sign on (SSO) tokens are only good for a few minutes while trying to be validated. Please either try again or reach out to our Support team for further assistance (info at the bottom of this page).";
    }
  }

  validateUser(userID){      
      localStorage.setItem('bearer', userID);
      localStorage.setItem('expiresIn', "3599");
      localStorage.setItem('loginTime', Date.now().toString());

      this.authService.loginSSO()
        .subscribe(
          data => {
            this.router.navigate(['/home']);
          },
          error => { 
            this.error = 'Incorrect username or password.';
            this.message = "There was an issue connecting to your account. Please either try again or reach out to our Support team for further assistance (info at the bottom of this page).";
          });      
  }  
}
